const PAGES = [
  { d: "M55 75 L500 40 Q528 42 528 70 L540 460 Q540 488 512 490 L470 492 Z", fill: "url(#bl-g4)", delay: "0.36s" },
  { d: "M55 75 L455 110 L470 560 L400 552 Z", fill: "url(#bl-g3)", delay: "0.24s" },
  { d: "M55 75 L385 195 L400 645 L330 620 Z", fill: "url(#bl-g2)", delay: "0.12s" },
  { d: "M55 75 L315 300 L330 690 Q328 715 300 705 L70 522 Z", fill: "url(#bl-g1)", delay: "0s" },
];

export const BookLoader = ({ size = 64, className = "" }) => (
  <svg viewBox="40 30 520 700" width={size} height={size * 1.35} className={`bl-svg ${className}`} role="img" aria-label="Loading" data-testid="brand-loader">
    <defs>
      <linearGradient id="bl-g1" x1="0" y1="0" x2="0.4" y2="1"><stop offset="0" stopColor="#A33AF0" /><stop offset="1" stopColor="#1A3CF0" /></linearGradient>
      <linearGradient id="bl-g2" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stopColor="#0B4DF0" /><stop offset="1" stopColor="#1A8CFF" /></linearGradient>
      <linearGradient id="bl-g3" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stopColor="#1A8CFF" /><stop offset="1" stopColor="#45BFF0" /></linearGradient>
      <linearGradient id="bl-g4" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stopColor="#3FC9E8" /><stop offset="1" stopColor="#45EBC0" /></linearGradient>
    </defs>
    {PAGES.map((p) => <path key={p.delay} d={p.d} fill={p.fill} className="bl-page" style={{ animationDelay: p.delay }} />)}
  </svg>
);

export const LoaderScreen = ({ label = "Opening your book", progress, testid = "loader-screen", children }) => (
  <div className="grid h-[100dvh] place-items-center bg-[#EEF2F8]" data-testid={testid}>
    <div className="flex flex-col items-center text-center">
      <div className="bl-float grid h-32 w-32 place-items-center rounded-[2rem] neu-raised"><BookLoader size={56} /></div>
      <p className="mt-7 font-display text-base font-bold text-[#0F172A]" data-testid="loader-label">{label}</p>
      <div className="mt-3 h-1 w-44 overflow-hidden rounded-full bg-[#DCE3EE]">
        {progress == null
          ? <div className="bl-shimmer h-full w-1/3 rounded-full brand-strip" />
          : <div className="h-full rounded-full brand-strip transition-[width] duration-500" style={{ width: `${Math.max(4, progress)}%` }} data-testid="loader-progress" />}
      </div>
      {children}
    </div>
  </div>
);
